import { render, staticRenderFns } from "./AttachmentFileUploader.vue?vue&type=template&id=99a08f92&scoped=true&"
import script from "./AttachmentFileUploader.vue?vue&type=script&lang=js&"
export * from "./AttachmentFileUploader.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentFileUploader.vue?vue&type=style&index=0&id=99a08f92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99a08f92",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCardText,VCardTitle,VChip,VContainer,VFileInput,VIcon,VRow,VSpacer})
